// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RoomSize from '../_raw/service/icon_room_size.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RoomSize);
